import { useAtomValue } from "jotai";
import { useState } from "react";
import { ProvideAppDevStateRenderers } from "#scripts/lib/dev/app-dev-state-renderers.tsx";
import type { WorldState } from "#scripts/vmc/WorldState.ts";
import type { World } from "#scripts/vmc/WorldState.ts";
import { ProvideWorldStateDev } from "./ProvideWorldStateDev.tsx";
import { RemoteCursors } from "./RemoteCursors.tsx";
import { RectangleDemo } from "./scrolly-rectangle-demo/RectangleDemo.tsx";
import { CFeatureFlags } from "./scrolly-rectangle-demo/components.ts";
import type { RemoteCursor } from "./setupPresence.ts";
import { useComponent } from "./world-state-context.ts";

export function DemoApp({
  world,
  rectangleUID,
  onCursorsMount,
}: {
  world: WorldState;
  rectangleUID: World.UID;
  onCursorsMount: (setCursors: (cursors: RemoteCursor[]) => void) => void;
}) {
  const [remoteCursors, setRemoteCursors] = useState<RemoteCursor[]>([]);

  // Register cursor setter on mount
  useState(() => {
    onCursorsMount(setRemoteCursors);
  });

  return (
    <ProvideAppDevStateRenderers>
      <ProvideWorldStateDev data-loc="phosphor-blog/scripts/world-state-demo/DemoApp.tsx:31:29" data-name="ProvideWorldStateDev" className="" world={world}>
        <RectangleDemo entityUID={rectangleUID} />
        <ConditionalRemoteCursors cursors={remoteCursors} rectangleUID={rectangleUID} />
      </ProvideWorldStateDev>
    </ProvideAppDevStateRenderers>
  );
}

function ConditionalRemoteCursors({ cursors, rectangleUID }: { cursors: RemoteCursor[]; rectangleUID: World.UID }) {
  const featureFlags = useComponent(rectangleUID, CFeatureFlags);
  const activeFlags = useAtomValue(featureFlags.flagsAtom);

  if (!activeFlags.has("presence")) {
    return null;
  }

  return <RemoteCursors cursors={cursors} />;
}
